<template>
  <div class="profile-component-container">
    <h2 class="page-title">
      Profile
    </h2>
    <membership-widget
      :active-section="activeSection"
      :subscription-receipt="subscriptionReceipt"
      @set-active="setActive"
      @clear-active="clearActive"
    />
    <subscription-widget
      :active-section="activeSection"
      :subscription-receipt="subscriptionReceipt"
      :user="user"
    />
    <catalog-widget
      :active-section="activeSection"
      :user="user"
    />
    <journey-widget
      v-if="showJourney"
      :active-section="activeSection"
      @set-active="setActive"
      @clear-active="clearActive"
    />
    <unrealized-widget
      v-if="showUnrealized"
    />
    <activation-widget
      v-if="showActivators"
      :active-section="activeSection"
      @set-active="setActive"
      @clear-active="clearActive"
    />
    <customer-success-widget />
    <settings-widget
      v-if="!certApp"
      :active-section="activeSection"
    />
    <previewer-widget v-if="user.previewer" />
    <div>
      uid: {{ user.id }}
    </div>
  </div>
</template>

<script>
import AuthenticationMixin from '@/mixins/authentication';
import GlobalMixin from '@/mixins/global';
import ProfileMixin from '@/mixins/profile';

import ActivationWidget from '@components/profile/widgets/mastery/activation.vue';
import CatalogWidget from '@components/profile/widgets/mastery/catalog.vue';
import CustomerSuccessWidget from '@/components/profile/widgets/mastery/customer-success.vue';
import JourneyWidget from '@components/profile/widgets/mastery/journey.vue';
import MembershipWidget from '@components/profile/widgets/mastery/membership.vue';
import PreviewerWidget from '@components/profile/widgets/mastery/previewer.vue';
import SettingsWidget from '@components/profile/widgets/mastery/settings.vue';
import SubscriptionWidget from '@components/profile/widgets/mastery/subscription.vue';
import UnrealizedWidget from '@components/profile/widgets/mastery/unrealized.vue';

import { KonamiCode } from '@/classes/konami';

export default {
  components: {
    ActivationWidget,
    CatalogWidget,
    CustomerSuccessWidget,
    JourneyWidget,
    MembershipWidget,
    PreviewerWidget,
    SettingsWidget,
    SubscriptionWidget,
    UnrealizedWidget,
  },
  mixins: [AuthenticationMixin, GlobalMixin, ProfileMixin],
  data() {
    return {
      activeSection: null,
    };
  },
  computed: {
    showActivators() {
      return (
        this.$store.getters['activation/activators'].filter(
          (a) => a.activatorType !== 'Ase',
        ).length > 0
      );
    },
    showUnrealized() {
      const allUnrealized = this.$store.getters['purchaseReceipts/unrealized'];
      return allUnrealized?.length > 0;
    },
    showJourney() {
      const classificationConfigs = this.$store.getters['userProfileConfigs/get'][this.user.classificationId];
      if (classificationConfigs) {
        return (
          classificationConfigs.filter(
            (config) => config.userProfileColumnName !== 'studyGoal',
          ).length > 0
        );
      }
    },
    subscriptionReceipt() {
      return this.user.subscriptionReceipt;
    },
    user() {
      return this.$store.getters['user/get'];
    },
  },
  mounted() {
    if (this.user?.previewer) {
      console.log('It\'s dangerous to go alone, take this!');
      const easterEgg = new KonamiCode();
      easterEgg.activateListeners(this.$store);
    }
    this.$store.dispatch('ui/setProfileModalShown', 'profileShowModal');
    this.$router.push({ name: 'home' });
  },
  created() {
    this.$analytics.events.viewedProfileScreen();
    this.loadStripe();
    const active = this.$route.query.active;
    if (['Study Goal', 'Journey'].includes(active)) {
      this.activeSection = active;
    }
  },
  methods: {
    clearActive() {
      this.activeSection = null;
    },
    setActive(section) {
      this.activeSection = section;
    },
  },
};
</script>

<style lang='scss' scoped>
.profile-component-container {
  .page-title {
    @include charter-font;
    border-bottom: 2px solid #00d8f8;
    display: inline-block;
    font-size: rem-calc(32);
    margin-bottom: rem-calc(38);
  }
}
</style>
